import { render, staticRenderFns } from "./SliderNew3D.vue?vue&type=template&id=7d96e7de&scoped=true&"
import script from "./SliderNew3D.vue?vue&type=script&lang=js&"
export * from "./SliderNew3D.vue?vue&type=script&lang=js&"
import style0 from "./SliderNew3D.vue?vue&type=style&index=0&id=7d96e7de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96e7de",
  null
  
)

export default component.exports